// client/src/api.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

// Helper para requests admin/chat
export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Siempre manda cookies
});